<template>
    <div class="clearfix" id="home-box">
        <nav-header></nav-header>
        <div class="row mx-0">
            <div class="home-swiper-box">
                <swiper ref="mySwiper" :options="swiperOptions">
                    <swiper-slide v-for="(item,key) in imgData" :key="key">
                        <img :src="item.path" :alt="item.name" />
                        <!-- <div class="home-swiper-text">
                           设计讲究不将就
                        </div> -->
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
        <div class="row mx-0 px-0 home-icon-container">
            <div class="home-icon-box">
                <div class="home-flex-box text-center">
                    <div class="card border-0 mb-2 col-2 col-lg-2" v-for="(item,key) in iconData" :key="key" @click="goChildren(item.url,item.query)">
                        <img :src="item.path"/>
                        <div class="card-body pb-0">
                            <h4 class="mb-0">{{item.name}}</h4>
                            <p>{{item.desc}}</p>
                        </div>
                    </div>
                </div>
                <div class="home-icon-content">
                    <h3>
                        <span>起于初心</span>
                        <span>回归匠心</span>
                    </h3>
                    <div>因为喜欢所以热爱,因为热爱所以坚持，因为坚持所以更专业<br>
                        苏州时差设计制作有限公司从智造到制造再到品质控制,一直坚持讲究不将就的原则，并且都具有系统完善的流程体系,<br>
                        从而缩短客户与目标之间的差距,建立领先对手的品牌营销力。
                    </div>
                </div>
                <div class="row text-center home-subtitle-box" @click="readClick('/impress')">VIEW MORE</div>
            </div>
        </div>
        <div class="home-case-box">
            <div class="row mx-0" v-for="(item,key) in caseData" :key="key">
                <div class="col-4 col-lg-4 card border-0 px-0 py-0" v-for="(value,index) in item" :key="index" @click="caseDetails(value.id)">
                    <img :src="value.cover"/>
                    <div class="card-body pb-0">
                        <h4 class="mb-0">{{value.title}}</h4>
                        <p>项目内容：{{value.svccontent}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row text-center home-subtitle-box" @click="readClick('/case')">VIEW MORE</div>
        <div class="home-product-box">
            <div v-for="(item,key) in productData" :key="key" :class="['col-12','col-lg-'+12/productData.length]"> 
                <h4 class="mb-3">{{item.name}}</h4>
                <div class="clearfix" v-if="item.children.length>0">
                    <p v-for="(value,index) in item.children" :key="index" :title="value.title" @click="newsDetails(value.id)">{{value.title}}</p>
                </div>
                <p v-else>
                    暂无此类动态
                </p>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
// @ is an alias to /src
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import NavHeader from "@/components/navHeader.vue";
import Footer from "@/components/footer.vue";
import { selectCases } from '@/api/cases';
import { selectNews } from '@/api/news';

export default {
    name: "Home",
    components: {
        NavHeader,
        Swiper,
        SwiperSlide,
        Footer
    },
    data() {
        return {
            serveIndex: 0,
            //轮播图
            imgData: [
                {
                    path: require("../../public/images/home/slide/1.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/2.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/3.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/4.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/5.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/6.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/7.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/8.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/9.jpg"),
                    name: ""
                },
                {
                    path: require("../../public/images/home/slide/10.jpg"),
                    name: ""
                }
            ],
            //轮播配置项
            swiperOptions: {
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true // 允许点击小圆点跳转
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false // 手动切换之后继续自动轮播
                },
                loop: true,
                 navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            },
            //icon数据
            iconData: [
                {
                    path: require("../../public/images/home/icon.png"),
                    name: "主题空间",
                    desc: "THEME SPACE",
                    url: "/case",
                    query: {
                        type: 1
                    }
                },
                {
                    path: require("../../public/images/home/icon2.png"),
                    name: "品牌形象",
                    desc: "BRAND IMADE",
                    url: "/case",
                    query: {
                        type: 2
                    }
                },
                {
                    path: require("../../public/images/home/icon3.png"),
                    name: "样本画册",
                    desc: "BRAND IMADE",
                    url: "/case",
                    query: {
                        type: 3
                    }
                }
            ],
            //案例展示
            caseData: [
                // [
                //     {
                //         path: require("../../public/images/home/case1.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     },
                //     {
                //         path: require("../../public/images/home/case2.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     },
                //     {
                //         path: require("../../public/images/home/case3.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     }
                // ],
                // [
                //     {
                //         path: require("../../public/images/home/case4.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     },
                //     {
                //         path: require("../../public/images/home/case5.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     },
                //     {
                //         path: require("../../public/images/home/case6.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     }
                // ],
                // [
                //     {
                //         path: require("../../public/images/home/case7.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     },
                //     {
                //         path: require("../../public/images/home/case8.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     },
                //     {
                //         path: require("../../public/images/home/case9.png"),
                //         name: "苏州高铁新城新时代文明实践所",
                //         desc: "品牌策划、空间设计、物料设计"
                //     }
                // ]
            ],
            //
            productData: [
                {
                    name: "时差新闻",
                    children: []
                },
                {
                    name: "项目花絮",
                    children: []
                },
                {
                    name: "时差游记",
                    children: []
                    
                }
            ]
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        }
    },
    created() {},
    methods: {
        /**
         * @desc 跳转路由
         */
        goChildren(path,query) {
            this.$router.push({
                path,
                query
            })
        },
        /**
         * @desc 跳转案例详情
         */
        caseDetails(id) {
            this.$router.push({
                path: '/caseDetails',
                query: {
                    id
                }
            })
        },
        /**
         * @desc 跳转动态详情
         */
        newsDetails(id) {
            this.$router.push({
                path: '/newsDetails',
                query: {
                    id
                }
            })
        },
        /**
         * @desc 查看更多点击
         */
        readClick(url) {
            this.$router.push({
                path: url
            })
        },
        /**
         * @desc 获取时差动态数据
         */
        selectNews(type) {
            let params = {
                page: 1,
                size: 6,
                type: type + 1
            }
            selectNews(params).then(res => {
                this.productData[type].children = res.data;
            })
        },
        /**
         * @desc 获取案例数据
         */
        selectCases() {
            let params = {
                page: 1,
                size: 24
            }
            selectCases(params).then(res => {
                let array = [];

                res.data.forEach(item => {
                    item.cover = '/express_api' + item.cover;
                    if(array.length == 0) {
                        array.push([item]);
                    } else {
                        let length = array.length - 1;

                        if (array[length].length != 3) {
                            array[length].push(item);
                        } else {
                            array.push([item]);
                        }
                    }
                })
                this.caseData = array;
            })
        }
    },
    mounted() {
        this.productData.forEach((item,key) => {
            this.selectNews(key);
        })
        this.selectCases();
    }
};
</script>
<style lang="scss" scoped>
#home-box {
    overflow: hidden;
    margin-top: 80px;

    //轮播样式
    .home-swiper-box {
        width: 100%;
        overflow: hidden;
        position: relative;

        .swiper-button-next, 
        .swiper-button-prev {
            // border: 1px solid #cccccc;
            padding: 10px;
            color: #EDF0FB;
            width: 100px;
            height: 100px;

            &:hover {
                color: #DA4747;
            }
        }

        img {
            width: 100%;
            // max-height: 450px;
            // height: 890px;
        }

        .home-swiper-text {
            font-size: 90px;
            text-align: center;
            width: 100%;
            height: 160px;
            color: #fff;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            line-height: 2;
        }
    }

    .home-icon-container {
        height: 770px;
        width: 100%; 

        .home-icon-box {
            width: 1200px;
            height: 100%;
            margin: 0 auto;

            .home-flex-box {
                margin-top: 100px;
                display: flex;
                justify-content: space-around;

                .card {
                    position: relative;
                    cursor: pointer;

                    &::after {
                        display: block;
                        overflow: hidden;
                        height: 1px;
                        content: "";
                        width: 160px;
                        background: #DA4747;
                        position: absolute;
                        left: calc(100% + 20px);
                        top: 75px;
                    }
                    &:last-child::after {
                        height: 0;
                    }
                }

                img {
                    width: 150px;
                    height: 150px;
                    margin: auto;
                }
                
                h4 {
                    font-size: 18px;
                    color: #333333;
                }

                p {
                    color: #999999;
                    font-size: 12px;
                }
            }

            .home-icon-content {
                h3 {
                    margin: 50px auto;
                    color: #666666;
                    font-size: 36px;

                    span {
                        padding: 0 30px;

                        &:last-child {
                            border-left: 1px solid #9A9A9A;
                        }
                    }
                }

                div {
                    font-size: 16px;
                    line-height: 30px;
                    color: #333333;
                }
            }
        }
    }

    .home-subtitle-box {
        width: 100%;
        margin: 60px auto;
        height: 42px;
        color: #999999;
        font-size: 16px;
        background: url('../../public/images/home/view_bg.png') center center no-repeat;
        align-items: center;
        justify-content: center;
        transition: all 0.3s linear;
        cursor: pointer;

        &:hover {
            font-weight: bold;
        }
    }

    .home-case-box {
        // width: 1770px;
        margin: 0 75px;

        .card {
            position: relative;
            overflow: hidden;
            cursor: pointer;
            border-radius: 0;

            .card-body {
                // display: none;
                position: absolute;
                bottom: 0;
                background: rgba(0,0,0,.7);
                width: 100%;
                color: #fff;
                line-height: 24px;
                box-sizing: border-box;
                padding-left: 30px;
                text-align: left;
                transition: all 0.2s linear;
                transform: rotateY(90deg);

                h4 {
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                p {
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            img {
                height: 390px;
                transition: all 0.2s linear;
            }

            &:hover {
                img {
                    transform: scale(1.2);
                }
                .card-body {
                    // display: block;
                    transform: rotate(0);
                }
            }
        }
    }

    .home-product-box {
        width: 1200px;
        margin: 50px auto;
        display: flex;
        justify-content: space-between;
        text-align: left;

        &>div {
            flex: 1;
            
            h4 {
                color: #cc0000;
                font-size: 16px;
                line-height: 50px;
                font-weight: bold;
                border-bottom: 1px solid #ECECEC;
            }

            p {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;;
                font-size: 14px;
                color: #666666;
                transition: all 0.2s linear;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
}
// @media screen and (min-width: 1360px) and (max-width: 1910px) {
//     #home-box {
//         .home-case-box {
//             width: 1200px;
//         }
//     }
// }

@media screen and (max-width: 1260px){
    #home-box {
        .home-icon-container .home-icon-box,
        .home-product-box  {
            width: auto;
            margin: 50px auto;
        }
    }
}
</style>
<style>
#home-box .swiper-pagination-bullet-active {
    background: #cc0000;
}
</style>
